export default "__VITE_ASSET__8edeb6ed__"